import React from 'react';
import { IconTrendingUp, IconCalendar } from 'src/icons';
import { formatNumber } from './utils';
import type { AnalyticsData } from './types';

interface GrowthMetricsCardProps {
  data: Pick<AnalyticsData, 'newUsersThisWeek' | 'newUsersThisMonth' | 'engagementRate'>;
  timeRangeLabel: string;
}

export function GrowthMetricsCard({ data, timeRangeLabel }: GrowthMetricsCardProps) {
  const { newUsersThisWeek, newUsersThisMonth, engagementRate } = data;
  const rate = engagementRate ?? 0;
  return (
    <div className="flex flex-col bg-white p-1.5 border border-gray-200 rounded min-w-0 min-h-0">
      <div className="flex justify-between items-center gap-0.5 mb-0.5 shrink-0">
        <h3 className="font-semibold text-[10px] text-gray-900">Growth</h3>
        <span className="text-[9px] text-indigo-600 shrink-0">{timeRangeLabel}</span>
      </div>

      <div className="flex-1 gap-1 grid grid-cols-2 min-h-0">
        <div className="flex justify-between items-center bg-amber-50 p-1 rounded min-w-0">
          <div className="min-w-0">
            <p className="text-[9px] text-gray-600">Weekly</p>
            <p className="font-bold text-gray-900 text-xs truncate">{formatNumber(newUsersThisWeek)}</p>
          </div>
          <IconTrendingUp className="w-3 h-3 text-amber-600 shrink-0" />
        </div>
        <div className="flex justify-between items-center bg-indigo-50 p-1 rounded min-w-0">
          <div className="min-w-0">
            <p className="text-[9px] text-gray-600">Monthly</p>
            <p className="font-bold text-gray-900 text-xs truncate">{formatNumber(newUsersThisMonth)}</p>
          </div>
          <IconCalendar className="w-3 h-3 text-indigo-600 shrink-0" />
        </div>
      </div>

      <div className="bg-gray-50 mt-0.5 p-1 rounded min-w-0 shrink-0">
        <div className="flex justify-between items-center">
          <span className="text-[9px] text-gray-600">Engage</span>
          <span className="font-bold text-[10px] text-gray-900 shrink-0">{rate}%</span>
        </div>
        <div className="bg-gray-200 mt-0.5 rounded-full h-1 overflow-hidden">
          <div
            className="bg-green-500 h-full transition-all duration-500"
            style={{ width: `${Math.min(rate, 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
}
